import React, { useState, useRef, useEffect } from "react";

const BackgroundMusicWithControl = () => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const defaultVolume = 0.05; // Default volume is 5%

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = defaultVolume;
        }
    }, []);

    const togglePlayPause = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause(); 
            } else {
                audioRef.current.play(); 
            }
            setIsPlaying(!isPlaying); 
        }
    };

    return (
        <div>
            <audio ref={audioRef} loop>
                <source src="/assets/Pufino - Thoughtful (freetouse.com).mp3" type="audio/mp3" />
                Your browser does not support the audio element.
            </audio>

            <button
                onClick={togglePlayPause}
                className="play-pause-btn"
                style={{
                    padding: "10px",
                    backgroundColor: "#11485B",
                    color: "#fff",
                    borderRadius: "50%",
                    cursor: "pointer",
                    fontSize: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "fixed",
                    bottom: "20px", 
                    left: "20px",    
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",  
                    zIndex: 1000,    
                }}
            >
                {isPlaying ? (
                   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ width: "24px", height: "24px" }}>
                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 19V5m12 14V5" />
               </svg>
                ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ width: "24px", height: "24px" }}>
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v18l15-9-15-9z" />
                </svg>
                )}
            </button>
        </div>
    );
};

export default BackgroundMusicWithControl;
